import { render } from "./productosCatalogosManager1.vue?vue&type=template&id=f0d0f6d8"
import script from "./productosCatalogosManager1.vue?vue&type=script&lang=js"
export * from "./productosCatalogosManager1.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__